"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
function default_1(event, prevState = {}) {
    var _a;
    const order = prevState;
    if ((_a = event.courseIds) === null || _a === void 0 ? void 0 : _a.length) {
        const updatedCourseCalls = (order.courseCalls || [])
            .map(call => {
            var _a;
            return ((_a = event.courseIds) === null || _a === void 0 ? void 0 : _a.includes(call.courseId))
                ? { ...call, isPrinted: true }
                : call;
        })
            .sort((a, b) => b.calledAt - a.calledAt);
        return { ...order, courseCalls: updatedCourseCalls };
    }
    const orderItems = order.orderItems || [];
    orderItems.forEach(item => {
        var _a;
        if (utils_1.VALID_FIRE_ITEM_STATUS.includes(item.status)) {
            item.itemFired = true;
            //Update combo item
            (_a = item.comboItems) === null || _a === void 0 ? void 0 : _a.forEach(comboItem => {
                if (utils_1.VALID_FIRE_ITEM_STATUS.includes(comboItem.status))
                    comboItem.itemFired = true;
            });
        }
    });
    if (order.orderItems) {
        order.orderItems = (0, utils_1.mergeIdenticalOrderItems)(order.orderItems);
    }
    return order;
}
exports.default = default_1;
//# sourceMappingURL=kitchenPrint.js.map